<template>
    <TextButton title="Visa" link="/visa" id="visa-subnavigationTitle" />

    <div class="my-1 flex flex-wrap justify-between">
        <div class="lg:w-1/2 w-full">
            <FullButton
                title="Quittungen"
                link="/visa/receipts"
                width="95"
                colour="red"
                id="visa-subnavigationButton1"
            />
        </div>
        <div class="lg:w-1/2 w-full text-right">
            <FullButton
                title="Archiv"
                link="/visa/archive"
                width="95"
                colour="red"
                id="visa-subnavigationButton2"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import TextButton from '@/components/Buttons/TextButton.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
</script>
